import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  return (
    <header className="bg-white shadow-md border-b-4 border-brand-500 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center">
            <h1 className="text-2xl sm:text-3xl font-bold text-brand-500">99prop.com</h1>
          </Link>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-4 lg:space-x-8">
            <Link
              to="/?start=true"
              className={`px-3 lg:px-4 py-2 rounded-lg font-semibold transition text-sm lg:text-base ${
                location.pathname === "/"
                  ? "bg-brand-500 text-white"
                  : "text-gray-700 hover:bg-brand-50"
              }`}
              data-testid="nav-check-value"
            >
              Check Value
            </Link>
            <Link
              to="/buy-property"
              className={`px-3 lg:px-4 py-2 rounded-lg font-semibold transition text-sm lg:text-base ${
                location.pathname === "/buy-property"
                  ? "bg-brand-500 text-white"
                  : "text-gray-700 hover:bg-brand-50"
              }`}
              data-testid="nav-buy-property"
            >
              Buy Property
            </Link>
            <Link
              to="/buyer-strategy"
              className={`px-3 lg:px-4 py-2 rounded-lg font-semibold transition text-sm lg:text-base ${
                location.pathname === "/buyer-strategy"
                  ? "bg-brand-500 text-white"
                  : "text-gray-700 hover:bg-brand-50"
              }`}
            >
              Buyer Strategy
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden focus:outline-none p-2 rounded-lg"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24">
                <path d="M6 18L18 6M6 6l12 12" stroke="#0d4040" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            ) : (
              <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24">
                <path d="M4 6h16M4 12h16M4 18h16" stroke="#0d4040" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200 bg-white">
            <nav className="flex flex-col space-y-2">
              <Link
                to="/?start=true"
                onClick={() => setMobileMenuOpen(false)}
                className={`px-4 py-3 rounded-lg font-semibold transition ${
                  location.pathname === "/"
                    ? "bg-brand-500 text-white"
                    : "text-gray-700 hover:bg-brand-50"
                }`}
              >
                Check Value
              </Link>
              <Link
                to="/buy-property"
                onClick={() => setMobileMenuOpen(false)}
                className={`px-4 py-3 rounded-lg font-semibold transition ${
                  location.pathname === "/buy-property"
                    ? "bg-brand-500 text-white"
                    : "text-gray-700 hover:bg-brand-50"
                }`}
              >
                Buy Property
              </Link>
              <Link
                to="/buyer-strategy"
                onClick={() => setMobileMenuOpen(false)}
                className={`px-4 py-3 rounded-lg font-semibold transition ${
                  location.pathname === "/buyer-strategy"
                    ? "bg-brand-500 text-white"
                    : "text-gray-700 hover:bg-brand-50"
                }`}
              >
                Buyer Strategy
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
